import BasicButton from 'core/BasicButton';
import ScrollButton from 'core/ScrollButton';

import cn from './style.module.sass';
export default function ApplicationBlock() {
    return (
        <div className={cn.applicationBlock}>
            <div className={cn['applicationBlock__top']}>
                <div className={cn['applicationBlock__top-title']}>
                    Специалист на расстоянии клика
                </div>
                <div className={cn['applicationBlock__top-description']}>
                    Вам не нужно беспокоиться о найме, обучении и управлении персоналом
                </div>
            </div>
            <div className={cn['applicationBlock__bot']}>
                <ScrollButton to="offer-body" smooth={true}>
                    <BasicButton className={cn['applicationBlock__bot-button']}>
                        Оставить заявку
                    </BasicButton>
                </ScrollButton>
            </div>
        </div>
    );
}
